// extracted by extract-css-chunks-webpack-plugin
module.exports = {"blue":"blue___M53ct","muted":"muted___1DPWQ","label":"label___Y6331","rightLabel":"rightLabel___2MqU_"};